/**
 * Directive: combobox
 */
angular.module('acme.common.directive.combobox', [
  'acme.common.directive.inputFieldError'
])
.directive('combobox', ['$timeout', function($timeout) {

    return {
      restrict: 'A',
      replace: true,
      require: 'ngModel',
      transclude: true,
      templateUrl: 'common/directives/combobox/combobox.tpl.html',
      scope: {
        items: '=',
        label: '@',
        name: '@',
        icon: '@',
        disabled: '=',
        readonly: '@',
        appendToBody: '@',
        templateUrl: '@',
        validTest: '=validtest',
        errorMessage: '=errormessage',
        errors: '=',
        addNewLabel: '@',
        addNewAction: '&',
        searchAction: '&',
        removeOnClear: '@',
        onBlur: '&',
        required: '@',
        dropdownClass: '@',
        stopEventOnSelect: '@',
        buttonIcon: '@',
        removeClearButton: '@',
        waitTime: '='
      },

      link: function($scope, $element, $attrs, ngModelCtrl) {
        // Modified after controller runs
        ngModelCtrl.$formatters.push(function(modelValue) {
          return modelValue ? {
            model: modelValue
          } : {
            model: ''
          };
        });

        $scope.combobox.onChange = function(item)
        {
          ngModelCtrl.$setViewValue(item);
        };

        ngModelCtrl.$render = function () {
          $scope.combobox.model = ngModelCtrl.$viewValue.model;
        };
      },

      controller: ['$scope', function($scope) {

        $scope.combobox = {
          isOpen: false,

          model: {},

          showNew: {
            addNewLabel: 'New',
            addNew: true
          },

          options: {
            debounce: 0
          },

          queryTimer: null,

          init: function() {

            this.options.debounce = $scope.waitTime || 0;

            this.appendToBody = ($scope.appendToBody);
            this.templateUrl = $scope.templateUrl || '';
            this.showNewItem = false;

            if ($scope.addNewLabel) {
              this.showNew.addNewLabel = $scope.addNewLabel;
            } else {
              this.showNew = false;
            }

            this.buttonIcon = $scope.buttonIcon || 'fa-caret-down';
          },

          showAutoComplete: function(field) {

            var fieldId = field + '-' + $scope.name || '',
                input = $('#'+fieldId);
            if ($scope.disabled === undefined || $scope.disabled === false || $scope.disabled === "false") {
              this.reduceList = false;
              $timeout(function () {
                input.trigger('focus');
              }, 0);
            }

          },

          checkValid: function() {
            var r = true;

            if ($scope.errorMessage) {
              r = (($scope.validTest !== undefined) ? $scope.validTest : true);
            } else {
              r = !this.error;
            }

            return r;
          },

          addNewAction: function() {
            if(this.shouldShowNewItem) {
              this.showNewItem = true;
            }
            if (typeof $scope.addNewAction === 'function') {
              $scope.addNewAction({added: true});
            }
          },

          removeNewAction: function() {
            this.showNewItem = false;
            if (typeof $scope.addNewAction === 'function') {
              $scope.addNewAction({added: false});
            }
          },

          clear: function() {
            $scope.combobox.model = '';
            $scope.combobox.onChange($scope.combobox.model);
          },

          filterList: function(type) {

            var self = $scope.combobox,
                timeout = (type === 'focus' && self.options.debounce) ? self.options.debounce : 0;

            if (self.queryTimer) {
              $timeout.cancel(self.queryTimer);
            }

            self.queryTimer = $timeout(function () {

              if (typeof($scope.searchAction) === 'function') {
                $scope.searchAction({searchText: typeof self.model === 'string' ? angular.copy(self.model) : self.model.name || ''});
              }
            }, timeout);
          },

          isRequired: function() {
            return $scope.required === "true";
          },

          onBlur: function(e) {
            if (!$scope.combobox.model) {
              $scope.combobox.onChange($scope.combobox.model);
            }
            if (typeof($scope.onBlur) === 'function') {
              $scope.onBlur(e, $scope.combobox.model);
            }
          }

        };

        $scope.combobox.init();

      }]

    };

}]);